/* eslint-disable no-unused-vars */
import { get } from "lodash";
import { axiosPublic, axiosPrivate } from ".";
import store from "../store";

export const sendInvite = params =>
  axiosPrivate.post(
    "email_marketing/email/teste/enviar",
    {
      loja: store.getters.storeSequencial,
      ...params,
    },
    {
      cache: true,
    }
  );

export const listInvites = params =>
  axiosPrivate.post(
    "email_marketing/listar",
    {
      loja: store.getters.storeSequencial,
      ...params,
    },
    {
      cache: true,
    }
  );

export const registerInvitation = params =>
  axiosPrivate.post(
    "email_marketing/cadastrar",
    {
      loja: store.getters.storeSequencial,
      ...params,
    },
    {
      cache: true,
    }
  );

export const listNewsletterConsumer = params =>
  axiosPrivate.post(
    "convite/consumidor/listar",
    {
      loja: store.getters.storeSequencial,
      ...params,
    },
    {
      cache: true,
    }
  );

export const editInvite = params =>
  axiosPrivate.post(
    "email_marketing/editar",
    {
      loja: store.getters.storeSequencial,
      ...params,
    },
    {
      cache: true,
    }
  );

export const sendImagem = params =>
  axiosPrivate.post(
    "email_marketing/media/upload",
    {
      loja: store.getters.storeSequencial,
      ...params,
    },
    {
      cache: true,
    }
  );

export const sendGuests = params =>
  axiosPrivate.post(
    "email_marketing/email/enviar",
    {
      ...params,
    },
    {
      cache: true,
    }
  );

export const getByInvite = params =>
  axiosPrivate.post("email_marketing/buscar", {
    loja: store.getters.storeSequencial,
    ...params,
  });

export const getEdit = params =>
  axiosPrivate.post("email_marketing/editar", {
    loja: store.getters.storeSequencial,
    ...params,
  });

export const deleteInvite = params =>
  axiosPrivate.post(
    "email_marketing/remover",
    {
      ...params,
    },
    {
      cache: true,
    }
  );
